














import { Component, Vue } from "vue-property-decorator";
const ButtonProps = Vue.extend({
  props: {
    btnText: String,
    btnType: String,
  },
});
@Component<Button>({})
export default class Button extends ButtonProps {
  public clicked() {
    this.$emit("click");
  }
  get btnImage() {
    let src = "ButtonS/ui.png";
    switch (this.btnType) {
      case "SW":
        src = "ButtonS/ui.png";
        break;
      case "SC":
        src = "ButtonS/ui-1.png";
        break;
      case "LW":
        src = "ButtonL/ui.png";
        break;
      case "LC":
        src = "ButtonL/ui-1.png";
        break;
    }
    return require(`../../assets/site/${src}`);
  }
  get btnHeight() {
    switch (this.btnType) {
      case "SW":
      case "SC":
        return 50;
      case "LW":
      case "LC":
        return 50;
    }
    return 50;
  }
  get btnWidth() {
    switch (this.btnType) {
      case "SW":
      case "SC":
        return 100;
      case "LW":
      case "LC":
        return 200;
    }
    return 100;
  }
}
